module.exports = __webpack_public_path__ + "27.dae564b3.png";